/**
 * Activity History Component
 * Displays list of activities for a company with empty state
 */
import { Clock, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ActivityItem } from "../../../components/activity";

export function ActivityHistory({ 
  activities, 
  companyId,
  isDesktop,
  isAdmin,
  onOutcomeClick,
  onEmailOutcomeClick,
  onDeleteClick 
}) {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden animate-fadeIn">
      {/* Header */}
      <div className="p-4 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Clock size={18} className="text-gray-500" />
          <h3 className="font-semibold text-gray-900 tracking-tight">Povijest</h3>
        </div>
        {isDesktop && (
          <button
            onClick={() => navigate(`/company/${companyId}/activity/new`)}
            data-testid="add-activity-button-desktop"
            className="px-4 py-2 bg-[#1B3F8F] text-white text-sm font-medium rounded-lg hover:bg-[#152f6b] transition-colors flex items-center gap-2"
          >
            <Plus size={16} />
            Dodaj aktivnost
          </button>
        )}
      </div>
      
      {/* Content */}
      <div className="p-4">
        {activities.length === 0 ? (
          <ActivityEmptyState />
        ) : (
          <div>
            {activities.map((activity) => (
              <ActivityItem 
                key={activity.id} 
                activity={activity} 
                onOutcomeClick={onOutcomeClick} 
                onEmailOutcomeClick={onEmailOutcomeClick}
                onDeleteClick={onDeleteClick} 
                isAdmin={isAdmin} 
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

/**
 * Empty state for activity history
 */
function ActivityEmptyState() {
  return (
    <div className="py-8 text-center">
      <div className="w-14 h-14 rounded-full bg-gray-100 mx-auto flex items-center justify-center mb-3">
        <Clock size={24} className="text-gray-400" />
      </div>
      <p className="text-gray-500 text-sm">Nema aktivnosti</p>
      <p className="text-gray-400 text-xs mt-1">Dodajte prvu aktivnost za ovu firmu</p>
    </div>
  );
}
